import moment from 'moment'

import 'moment/locale/vi'

import 'moment-timezone'

moment.tz.setDefault('Asia/Ho_Chi_Minh')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
